module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/align-center-ae4584fbd275b5225b53977749a69395.svg";